// src/components/Projects/projectsData.js

const projects = [
  {
    id: "ka171-connecting-continents",
    slug: "erasmus-ka171-connecting-continents",
    i18nKey: "ka171",
    category: "erasmus",
    link: "/projekti/erasmus-ka171-connecting-continents",

    // shared/meta data
    startDate: "01.08.2025",
    endDate: "31.07.2028",
    durationMonths: 36,
    universitiesCount: 31,
    countriesCount: 24,
    projectNo: "2025-1-BG01-KA171-HED-000339139",

    // images/logos
    coverImage: "/assets/img/projects/KA171/ccemKA171_logo.png",
    logoImage: "/assets/img/projects/KA171/about_ccemKA171.png",
    logos: {
      eu: "/assets/img/projects/eu-emblem.jpg",
      main: "/assets/img/projects/KA171/ccemKA171_logo2.png",
      partner: "/assets/img/projects/KA171/ccem_schoolLogo.png",
      erasmus: "/assets/img/projects/erasmus1.jpg",
    },

    // tags for cards
    tags: [
      "#ErasmusPlusKA171",
      "#HigherEducation",
      "#InternationalMobility",
      "#GlobalEducation",
      "#AcademicCollaboration",
      "#Internationalisation",
      "#ErasmusProject",
      "#EUfunded",
    ],

    hashtagLink:
      "https://www.linkedin.com/search/results/content/?keywords=%23ErasmusPlusKA171&origin=GLOBAL_SEARCH_HEADER&sid=RY9",

    social: {
      facebook: "https://www.facebook.com/IBSEDU/",
      instagram: "https://www.instagram.com/ibsedu/",
      linkedin:
        "https://www.linkedin.com/school/international-business-school-bulgaria/",
      tiktok: "https://www.tiktok.com/@ibs.bulgaria",
    },
  },
  {
    id: "res-uni-research-universities",
    slug: "res-uni",
    i18nKey: "resuni",
    category: "erasmus",
    link: "/projekti/res-uni",

    // meta
    projectNo: "101179358",
    projectNoFull: "101179358 - Res-Uni - ERASMUS-EDU-2024-CBHE",
    durationMonths: 36,
    universitiesCount: 9,
    countriesCount: 6,

    // images
    coverImage: "/assets/img/projects/resuni/resuni_cover.png",
    logoImage: "/assets/img/projects/resuni/resuni_logo.png",
    logos: {
      eu: "/assets/img/projects/eu-emblem.jpg", // koristi postojeći EU emblem
      main: "/assets/img/projects/resuni/resuni_logo.png",
    },

    // official website
    website: "https://resuni.firat.edu.tr/",

    // tags
    tags: [
      "#resuni",
      "#ErasmusPlus",
      "#CBHE",
      "#ResearchUniversities",
      "#ResUni",
    ],

    // socials from cover
    social: {
      instagram: "https://www.instagram.com/res__uni/",
      twitter: "https://x.com/res__uni",
      youtube: "https://www.youtube.com/@ResUni-Erasmus",
    },
  },

  {
    id: "lands",
    slug: "lands",
    i18nKey: "lands",
    category: "interreg",
    link: "/projekti/lands",

    coverImage: "/assets/img/projects/lands/lands_cover.png",

    // logo set (koristi se na single page)
    logos: {
      project: "/assets/img/projects/lands/lands_logo.png",
      // ako već koristiš EU emblem globalno, možeš i ovo:
      // eu: "/Prilozi/KA171/eu-emblem.png",
    },

    // za sidebar / karticu
    startDate: "2024-09-01",
    endDate: "2027-02-28",
    partnersCount: 11,
    countriesCount: 9,

    // optional tags za karticu
    tags: [
      "#Interreg",
      "#Sensors",
      "#RiskPrediction",
      "#SMEs",
      "#PilotActions",
    ],
  },

  {
    id: "reimagine",
    slug: "reimagine",
    i18nKey: "reimagine",
    category: "horizon",
    coordinator: "Belgrade Metropolitan University (BMU)",
    funding: "REINFORCING-HORIZON (Incubator Project)",
    duration: "01.11.2025 - 31.10.2026",
    countries: "2 partner universities",

    website: "https://www.metropolitan.ac.rs/reimagine/",
    reinforcingWebsite: "https://reinforcing.eu/",

    social: {
      linkedin: "https://www.linkedin.com/company/re-imagine-project/",
    },

    tags: [
      "#REIMAGINE",
      "#REINFORCING",
      "HorizonEurope",
      "#ORRI",
      "#ResponsibleInnovation",
      "#ResponsibleDigitalisation",
      "AIinEducation",
      "#HigherEducation",
      "#EthicsInPractice",
    ],
    link: "/projekti/reimagine",
    coverImage: "/assets/img/projects/reimagine/reimagine_cover.png",
    logoImage: "/assets/img/projects/reimagine/reimagine.png",
  },

  {
    id: "digicreate",
    slug: "digicreate",
    i18nKey: "digicreate",
    category: "erasmus", // Erasmus+ Virtual Exchanges

    // basic meta
    coordinator: "Youth Power Germany e.V. (YP-DE)",
    programme: "Erasmus+ Virtual Exchanges",
    duration: "36 months",
    targetGroup: "Youth (18–30)",

    // scope
    countries:
      "Germany, Spain, Portugal, Serbia, Bosnia & Herzegovina, Montenegro",
    participantsCount: 2500,

    // official references
    website: "https://digicreate-empower.eu/",
    erasmusWebsite: "https://erasmus-plus.ec.europa.eu/",

    // social & dissemination
    social: {
      linkedin: "https://www.linkedin.com/",
    },

    // routing
    link: "/projekti/digicreate",

    // visuals (ti ćeš dodati fajlove, imena su konzistentna)
    coverImage: "/assets/img/projects/digicreate/digicreate_cover.png",
    partnersImage: "/assets/img/projects/digicreate/digicreate_partners.png",

    // tags for cards & SEO
    tags: [
      "#DigiCreate",
      "#ErasmusPlus",
      "#VirtualExchange",
      "#Youth",
      "#CreativeIndustries",
      "#DigitalSkills",
      "#InterculturalDialogue",
      "#WesternBalkans",
    ],
  },

  {
    id: "prodigy-e",
    slug: "prodigy-e",
    i18nKey: "prodigye",
    category: "erasmus",
    link: "/projekti/prodigy-e",

    // meta / quick facts (safe, not over-specific)
    programme: "Erasmus+ CBHE (Strand 1)",
    call: "ERASMUS-EDU-2025-CBHE (Strand 1)",
    coordinator: "Visoka poslovno tehnička škola Doboj (VPTSD)",
    partnersCount: 8,

    // optional links (portal link from your email; might start working later)
    links: {
      euPortal:
        "https://ec.europa.eu/info/funding-tenders/opportunities/portal/screen/opportunities/projects-details/43353764/101236407",
    },

    // tags for cards & SEO
    tags: [
      "#Erasmus+",
      "#CBHE",
      "#Digital Transformation",
      "#Innovation",
      "#Project Management",
      "#Higher Education",
      "#Student Innovation Hubs",
      "#Institutions",
      "#International Cooperation",
      "#Employability & Skills",
    ],

    // visuals
    coverImage: "/assets/img/projects/prodigye/Prodigy-E Crni-1.png",
    logoImage: "/assets/img/projects/prodigye/Prodigy-E Crni-1.png",
  },
];

export default projects;
